import styles from "./styles.module.css"

export default function AlertModal({ title, message }) {
    return (
        <div className={styles.modalContainer}>
            <div className={styles.modalCard}>
                <h2 className={styles.modalCard__title} >{title}</h2>
                <p className={styles.modalCard__message} >{message}</p>
            </div>
        </div>
    );
}